import api from "../axios/api";
import Axios from "axios";
import { IService } from "../models/iservice";
import { IUpdateServiceBody } from "../store/actions/editService";
let CancelToken = Axios.CancelToken;

let fetchServiceById_cancel: any;

export const fetchServiceById = (id: string): Promise<IService> => {
  fetchServiceById_cancel && fetchServiceById_cancel()

  return api.get('/services/' + id, {
    cancelToken: new CancelToken(function executor(c) {
      fetchServiceById_cancel = c;
    })
  })
}

export const updateService = (index: string, body: IUpdateServiceBody): Promise<IService> => {
  fetchServiceById_cancel && fetchServiceById_cancel()

  return api.put('/services/' + index, body, {
    cancelToken: new CancelToken(function executor(c) {
      fetchServiceById_cancel = c;
    })
  })
}
